module.exports = __webpack_public_path__ + "static/img/m_name.7c63f73.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/lxx/m_name.png
// module id = cmRy
// module chunks = 7